import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "#041236",
      "clip-path": "url(#a)"
    }, [
      _createElementVNode("path", { d: "M4.726 4.785a2.6 2.6 0 0 1-1.934.822c-.757 0-1.416-.281-1.974-.822C.28 4.225 0 3.564 0 2.803S.28 1.362.818.821A2.68 2.68 0 0 1 2.792 0c.757 0 1.415.261 1.934.821.558.54.818 1.202.818 1.982s-.259 1.422-.818 1.982m14.456 14.389a2.6 2.6 0 0 1-1.934.821c-.757 0-1.416-.28-1.974-.821-.538-.56-.818-1.222-.818-1.982s.28-1.441.818-1.982a2.68 2.68 0 0 1 1.974-.821c.757 0 1.415.26 1.934.821.558.54.818 1.202.818 1.982s-.259 1.421-.818 1.982m-17.157-1.14C.72 16.722.052 15.139.052 13.3s.667-3.42 1.973-4.718c1.307-1.325 2.868-1.981 4.699-1.981s3.408.655 4.712 1.981c1.306 1.298 1.959 2.865 1.959 4.718 0 1.854-.653 3.422-1.959 4.732s-2.868 1.967-4.712 1.967-3.392-.655-4.699-1.967zm2.23-7.213a3.43 3.43 0 0 0-1.009 2.48c0 .967.341 1.781 1.009 2.479q1.043 1.026 2.469 1.026c.95 0 1.788-.342 2.47-1.026q1.02-1.047 1.021-2.48a3.4 3.4 0 0 0-1.022-2.48 3.36 3.36 0 0 0-2.469-1.025c-.964 0-1.775.342-2.47 1.026" })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "a" }, [
        _createElementVNode("path", {
          fill: "#fff",
          d: "M0 0h20v20H0z"
        })
      ])
    ], -1)
  ])))
}
export default { render: render }